import React from 'react'
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,

} from "@mui/material";
import instance from '../../Utils/api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Paymentstatus = ({ selectedPayment, statusDialog, setstatusDialog, setgetPayment }) => {

    const handleClose = () => {
        setstatusDialog(false);
    }

    //handlepaymentStatus
    const handlepaymentStatus = async () => {
        try {
            const response = await instance.put(`/Payment/resendNotification?payment_id=${selectedPayment.paymentId}`)
            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetPayment(true)
            } else {
                toast.error(response.data.message)
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message); // Handle errors
        }
    }
    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={statusDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Resend Payment Notification
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Typography>
                        Are you sure you want to resend the payment notification for <strong>{selectedPayment?.name}</strong>?
                        {/*  This will send an updated status to the user. */}
                    </Typography>
                </DialogContent>
                <DialogActions >
                    <Button className="cancel-btn" onClick={handleClose}>Cancel</Button>
                    <Button className="add-btn" onClick={handlepaymentStatus}>Send Notification</Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default Paymentstatus